import { render } from "./AddRecommendationProductModal.vue?vue&type=template&id=5fb15d99"
import script from "./AddRecommendationProductModal.vue?vue&type=script&lang=js"
export * from "./AddRecommendationProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__